export default "__VITE_ASSET__BHaG2tuB__"